import React from 'react';

import PropTypes from 'prop-types';

import './InputRow.sass';

export const InputRow = ({ children }) => (
  <div className={`input-row input-row${children?.length > 2 ? '__long' : '__short'}`}>
    {children?.length > 1 ? children.map((child) => child) : children}
  </div>
);

InputRow.propTypes = {
  children: PropTypes.node,
};

InputRow.defaultProps = {
  children: null,
};
